import { createFileRoute, redirect } from '@tanstack/react-router'
import { getLegacyHomeLoginSearch } from '../../../../utils/legacy-home-login-redirect'

export const Route = createFileRoute('/home/$mode/$token/')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/login',
      search: getLegacyHomeLoginSearch(params.mode, params.token)
    })
  }
})
